import * as yup from 'yup';

export const validationSchema = yup.object({
  firstName: yup.string().trim().required(),
  lastName: yup.string().trim().required(),
  employeeId: yup.string().trim().required(),
  phone: yup.string().required(),
});
